import { Pill, PILL_COLORS } from "components/ui/Pill";

const VACCINE_TYPE_PILL_COLORS = {
  "COVID-19": { color: "#1976d2", bg: "#e3f2fd", border: "#1976d2" },
  Influenza: { color: "#7b1fa2", bg: "#f3e5f5", border: "#7b1fa2" },
  Pneumococcal: { color: "#388e3c", bg: "#e8f5e8", border: "#388e3c" },
  PCI: { color: "#92400e", bg: "#fef3c7", border: "#fbbf24" },
  RSV: { color: "#0f766e", bg: "#ccfbf1", border: "#14b8a6" },
};

const DEFAULT_TYPE_PILL = { color: "#666", bg: "#f5f5f5", border: "#ccc" };

export const vaccinesColumns = [
  { key: "name", header: "Name", width: "minmax(120px, 1fr)", render: (row) => row.name || "-" },
  {
    key: "type",
    header: "Type",
    width: "115px",
    render: (row) => {
      if (!row.type) return "-";
      const pillColors = VACCINE_TYPE_PILL_COLORS[row.type] ?? DEFAULT_TYPE_PILL;
      return <Pill {...pillColors}>{row.type}</Pill>;
    },
  },
  {
    key: "status",
    header: "Status",
    width: "100px",
    render: (row) => (
      <Pill {...(row.disabled === true ? PILL_COLORS.sentNo : PILL_COLORS.sentYes)}>
        {row.disabled === true ? "Disabled" : "Enabled"}
      </Pill>
    ),
  },
  { key: "manufacturer", header: "Manufacturer", width: "135px", render: (row) => row.manufacturer || "-" },
  { key: "doseMl", header: "Dose (ml)", width: "105px", render: (row) => row.doseMl || "-" },
  {
    key: "ageRange",
    header: "Age Range",
    width: "145px",
    render: (row) =>
      row.startAge && row.endAge ? `${row.startAge} - ${row.endAge} months` : "-",
  },
  { key: "route", header: "Route", width: "105px", render: (row) => row.route || "-" },
  { key: "administrationMethod", header: "Method", width: "155px", render: (row) => row.administrationMethod || "-" },
];

export const vaccineCodesColumns = [
  { key: "name", header: "Name", width: "300px", render: (row) => row.name || "-" },
  {
    // Withdrawn products are retired with `active = false` rather than being deleted
    // (KIN-1698), because immunisation records still refer to them — so /all returns
    // them and this list shows them. Without this column they are indistinguishable
    // from products a clinician can still administer. Compared against false
    // explicitly, so a backend that does not report the field is not read as
    // "withdrawn". Second column on purpose: the table scrolls sideways, and a status
    // nobody scrolls to is no status at all.
    key: "active",
    header: "Status",
    width: "130px",
    testId: "healthlink-vaccine-status",
    render: (row) => (
      <Pill
        {...(row.active === false ? PILL_COLORS.sentNo : PILL_COLORS.sentYes)}
      >
        {row.active === false ? "Withdrawn" : "Administrable"}
      </Pill>
    ),
  },
  { key: "saleProprietaryName", header: "Sale Name", width: "285px", render: (row) => row.saleProprietaryName || "-" },
  { key: "code", header: "Code", width: "minmax(135px, 1fr)", render: (row) => row.code || "-" },
  { key: "snomedCode", header: "SNOMED", width: "170px", render: (row) => row.snomedCode || "-" },
  {
    key: "vaccineType",
    header: "Type",
    width: "120px",
    testId: "healthlink-vaccine-type",
    render: (row) => {
      if (!row.vaccineType) return "-";
      const pillColors = VACCINE_TYPE_PILL_COLORS[row.vaccineType] ?? DEFAULT_TYPE_PILL;
      return <Pill {...pillColors}>{row.vaccineType}</Pill>;
    },
  },
  {
    key: "cvxCode",
    header: "CVX",
    width: "75px",
    render: (row) => row.cvxCode ? <Pill {...DEFAULT_TYPE_PILL}>{row.cvxCode}</Pill> : "-",
  },
  {
    key: "mvxCode",
    header: "MVX",
    width: "57px",
    render: (row) => row.mvxCode ? <Pill {...DEFAULT_TYPE_PILL}>{row.mvxCode}</Pill> : "-",
  },
];
